import { apiClient } from "./client";

export const monitorCenterAPI = {
  metric(instanceName) {
    return apiClient.get(`/monitor-center/metric/${instanceName}`);
  },
  metricRange(instanceName, start, end) {
    return apiClient.get(`/monitor-center/metric_range/${instanceName}`, {
      params: {
        start_time: start,
        end_time: end,
      },
    });
  },

  connectedTime(startDate, endDate) {
    return apiClient.get<{ task_id: string }>(`/monitor-center/user-connected-time`, {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
    });
  },
  workingTime(startDate, endDate) {
    return apiClient.get<{ task_id: string }>("/monitor-center/user-working-time", {
      params: {
        start_date: startDate,
        end_date: endDate,
      },
    });
  },
};
